export const FILTER_BY_PROJECT_PREF = 'userDatasets.filterByProject';
